export const id = {
  "common.signOut": "Keluar",
  "common.loginRegister": "Masuk / Daftar",
  "common.follow": "Ikuti {brand}",
  "common.superAdmin": "● Super Admin",
  "common.viewer": "● Pengunjung",
  "common.language": "Bahasa",

  "lock.unlock": "Terbuka",
  "lock.locked": "Terkunci",

  "nav.database": "Database ECU",
  "nav.software": "Galeri Software",
  "nav.binConverter": "Converter",
  "nav.checksum": "Checksum",
  "nav.fileService": "Layanan File",
  "nav.pinout": "Pinout ECU",
  "nav.xdfAdx": "Buka XDF / ADX",
  "nav.immo": "IMMO Service",
  "nav.recovery": "Generator Recovery",
  "nav.mapEditor": "Map Editor",
  "nav.hondaFlashtools": "Honda Flash Tools",
  "nav.yamahaFlashtools": "Yamaha Flash Tools",
  "nav.autoMapFinder": "Auto Map Finder",
  "nav.seedKey": "Lihat Seed Key",
  "nav.diagram": "Alat Diagram",
  "nav.desktopApp": "Aplikasi Desktop",
  "nav.ecuDatabaseAdmin": "Update Info Bike",
  "nav.ecuLibrary": "Update Basemap",
  "nav.userControl": "Kontrol User",
  "nav.appUpdate": "Update Aplikasi",

  "guard.flashing": "Sedang flashing — tidak bisa keluar. Tekan Abort lalu Disconnect dulu.",
  "guard.leave": "Map Editor terkunci — ada editan belum disimpan, Flash Tools aktif, atau perangkat FTDI masih terhubung.\n\nTinggalkan halaman? Perubahan yang belum disimpan bisa hilang.",

  "mapeditor.narrowbandNote": "O2 narrowband: paling akurat di sekitar 14.7 (idle/cruise). Koreksi dibatasi ±{step}% per sel. Rekam sambil berkendara agar tiap area RPM×TPS terisi sampel.",
  "mapeditor.noSamples": "Belum ada sampel live. Aktifkan Live lalu Rekam sambil jalan.",

  "login.tagline": "ECU Tuning",
  "login.tabLogin": "Masuk",
  "login.tabRegister": "Daftar",
  "login.name": "Nama",
  "login.phone": "No. HP",
  "login.email": "Email",
  "login.country": "Negara",
  "login.password": "Password",
  "login.confirm": "Ulangi Password",
  "login.submitLogin": "Masuk",
  "login.submitRegister": "Buat Akun",
  "login.forgotQ": "Lupa password?",
  "login.forgotAction": "Reset via admin",
  "login.forgotHint": "Masukkan Nama, Email & No. HP akun Anda. Admin akan mengecek lalu menghubungi Anda dengan password Anda.",
  "login.forgotSubmit": "Kirim Permintaan ke Admin",
  "login.pendingTitle": "Menunggu persetujuan admin",
  "login.pendingBody": "Akun {email} sudah dibuat. Anda bisa login setelah admin menyetujui.",
  "login.backToLogin": "Kembali ke Login",
  "login.toastSuccess": "Login berhasil",
  "login.toastPwMismatch": "Password dan ulangi password tidak sama",
  "login.toastRegistered": "Akun dibuat — menunggu persetujuan admin",
  "login.toastForgotFill": "Isi minimal Nama dan Email",
  "login.toastForgotSent": "Permintaan dikirim ke admin",
  "login.err": "Terjadi kesalahan. Coba lagi.",
};
